export class DropdownNavigationModule {

	constructor() {
		this.$trigger = $("[data-dropnav-trigger]");
		this.$action = $("[data-dropnav-action]");
		this.$list = $(".dropdown-navigation--list");
		this.init();
	}

	init() {
		this.$trigger.on('click', (e) => { this.toggleNavigation() });
		$("body").on('click', (e) => { this.closeNavigationOnOutsideClick(e) });
		this.$list.on('keyup', (e) => { this.mimicNativeSelect(e) });
	}

	closeNavigationOnOutsideClick(evt) {
		if (!this.$trigger.hasClass('active') || $(evt.target).closest('[data-dropnav-root]').length) {
			return;
		}
		this.toggleNavigation();
	}

	toggleNavigation() {
		if (this.navigationIsOpen()) {
			this.closeNavigation();
		} else {
			this.openNavigation();
		}
	}

	closeNavigation() {
		this.$trigger.removeClass('active');
		this.$action.removeClass('active');
	}

	openNavigation() {
		this.$trigger.addClass('active');
		this.$action.addClass('active');
		this.$list.focus();
	}

	navigationIsOpen() {
		return this.$trigger.hasClass('active');
	}

	mimicNativeSelect(e) {

		if (e.keyCode == 27) {
			this.closeNavigation(); /* Close on escape */
		}

		let char = String.fromCharCode(e.keyCode);
		let isLetter = (/[a-zA-Z]/.test(char));

		if (!isLetter || !this.navigationIsOpen()) {
			return;
		}

		this.scrollToElement(char.toLowerCase());
	}

	scrollToElement(char) {
		let $element = $("[data-scrollto='" + char + "']").first();

		if (!$element.length) {
			return;
		}

		let offset = parseInt($element.offset().top);
		let offsetParent = parseInt($element.offsetParent().offset().top);
		let currentScrollInList = parseInt(this.$list.scrollTop());

		let calculatedOffset = (offset + currentScrollInList) - offsetParent;


		this.$list.animate({
			scrollTop: calculatedOffset
		});

	}
}
